import { render, staticRenderFns } from "./Worksectors.vue?vue&type=template&id=3b08bbbf"
import script from "./Worksectors.vue?vue&type=script&lang=js"
export * from "./Worksectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b08bbbf')) {
      api.createRecord('3b08bbbf', component.options)
    } else {
      api.reload('3b08bbbf', component.options)
    }
    module.hot.accept("./Worksectors.vue?vue&type=template&id=3b08bbbf", function () {
      api.rerender('3b08bbbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Worksectors/Worksectors.vue"
export default component.exports